module.exports = __webpack_public_path__ + "static/media/lv.9b38b0cd.svg";